import { useState, useCallback } from "react"

export const useItemExpansion = () => {
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set())

  const toggleExpanded = useCallback((itemId: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(itemId)) {
        newSet.delete(itemId)
      } else {
        newSet.add(itemId)
      }
      return newSet
    })
  }, [])

  const isExpanded = useCallback((itemId: number): boolean => {
    return expandedItems.has(itemId)
  }, [expandedItems])

  return {
    expandedItems,
    toggleExpanded,
    isExpanded
  }
}
